import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { STORY_DETAILS_PAGE_URL } from '../../../common/APi/apiurl';
import { formatStoryDetailsData } from "../../../common/utils/utils";
import he from 'he';
import ReactPlayer from 'react-player';
import { StoryDetailsPageResponse } from '../../../Service/StoriesDetails';

const StoryDetails: React.FC = () => {
    const location = useLocation().pathname;
    const [loading, setLoading] = useState<boolean>(true);
    const [pageContent, setContent] = useState<null | any>(null);
    const [storyData, setStoryData] = useState<any | null>(null);

    const fetchResponse = async () => {
        try {
            // Fetch header content
            const response = await StoryDetailsPageResponse(STORY_DETAILS_PAGE_URL);
            setContent(response);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    const formatData = () => {
        if (pageContent) {
            const storyPath = location.replace('/StoryDetails', '');
            const storyDetailsData = formatStoryDetailsData(pageContent, storyPath);
            if (storyDetailsData && storyDetailsData.length > 0) {
                setStoryData(storyDetailsData[0]);
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchResponse();
    }, [location]);
    useEffect(() => {
        formatData();
    }, [pageContent])

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!storyData) {
        return <div>Story not found</div>;
    }

    return (
        <Box className='blog blog-detail' sx={{marginTop:"20px"}}>
                <Container maxWidth={false} sx={{ maxWidth: '1332px' }}>
        <Box className='news-and-resource blog-detail' display='flex' justifyContent='center' mb={{ xs: '30px', lg: '98px' }}>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center">
            {storyData.field_blog_bannerimage !== "" ?
                <img src={storyData.field_blog_bannerimage} alt="" /> : ''}
            <Box className='news-box' display="flex" flexDirection="column" justifyContent="space-between"
                pl={{ xs: '20px', md: '24px' }} pr={{ xs: '20px', md: '56px' }} pt={{ xs: '20px', md: '56px' }} pb={{ xs: '20px', md: '40px' }} maxWidth='557px'>
              
                    <Box>
                        <Button href='#'></Button>                  
                        <Typography variant="h1"  mb="20px" fontSize={{lg:'34px', xl:'45px'}}>
                            {/* <div dangerouslySetInnerHTML={{ __html: commonData.title }} /> */}
                            {/* {truncateString(commonData?.title, 80)} */}
                            {/* {commonData.title } */}
                            {storyData.title}
                          </Typography>

                    </Box>
              
            </Box>
        </Box>
    </Box>
          {/* YouTube Video Section */}
           <Box sx={{ mb: 6, display: 'flex', justifyContent: 'center' }}>
     <Box
                        sx={{
                            width: '45vw',
                            aspectRatio: '16/9',
                            position: 'relative',
                            borderRadius: '8px',
                            overflow: 'hidden',
                        }}
                    >
                        <ReactPlayer
                            url={storyData.field_video}
                            width="100%"
                            height="100%"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                            }}
                        />
                    </Box>
                </Box>

                {/* Story Description */}
                <Box
                    sx={{
                        maxWidth: '800px',
                        marginBottom: '80px !important',
                        margin: '0 auto',
                        px: { xs: 2, md: 0 },
                        mb: { xs: 4, md: 6 }
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: { xs: '16px', md: '18px' },
                            lineHeight: 1.8,
                            color: '#666'
                        }}
                    >
                        {storyData.body && he.decode(storyData.body)}
                    </Typography>
                </Box>
    </Container>
    </Box>
    );
};

export default StoryDetails;




